// Shared ring spinner (ink on a hairline track) — the single app-wide loading indicator. Used by the
// route Suspense fallback (chunk load) and by data-gates (e.g. Arbuzino hydration)
// so there's one consistent loader instead of bespoke per-page spinners.
export function Spinner({ size = 32 }) {
  return (
    <span style={{
      width: size, height: size, borderRadius: '50%', display: 'inline-block',
      border: `${size >= 24 ? 3 : 2}px solid var(--rule)`, borderTopColor: 'var(--ink)',
      animation: 'mob-spin .8s linear infinite',
    }} />
  );
}

// Centered spinner for route-level Suspense fallbacks.
export function RouteFallback() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
      <Spinner />
    </div>
  );
}
